import React from "react";

const Amount = (props) => {
    return (
        <>
            {props.type} {props.value}
        </>
    );
};

export default Amount;
